// Stylised OpenStreetMap-like lesson map (vector, no stock imagery).
// Renders roads, fields, town labels, the driven route + dropped error pins.
export function LessonMap({ pins = [], showCurrent = false, className = "" }) {
  return (
    <div className={`relative w-full h-full overflow-hidden ${className}`} style={{ background: "#EDE7DC" }}>
      <svg viewBox="0 0 300 460" className="absolute inset-0 w-full h-full" preserveAspectRatio="xMidYMid slice">
        {/* green fields */}
        <g fill="#C9E3A8">
          <path d="M-10 40 L90 20 L120 70 L60 120 L-10 130 Z" />
          <path d="M200 -10 L320 10 L320 90 L230 80 L190 40 Z" />
          <path d="M250 120 L320 130 L320 240 L250 230 Z" />
          <path d="M-10 300 L70 290 L90 360 L-10 380 Z" />
          <path d="M120 380 L230 370 L260 470 L120 470 Z" />
          <path d="M170 150 L215 145 L230 200 L180 210 Z" />
        </g>
        <g fill="#B6D890" opacity="0.8">
          <ellipse cx="45" cy="205" rx="42" ry="26" />
        </g>
        {/* field dot texture */}
        <g fill="#A9CF84" opacity="0.6">
          {Array.from({ length: 40 }).map((_, i) => (
            <circle key={i} cx={(i * 53) % 300} cy={(i * 37) % 460} r="1.4" />
          ))}
        </g>
        {/* town block (grey) */}
        <path d="M95 150 L210 140 L235 260 L120 300 L80 250 Z" fill="#D9D6D0" opacity="0.75" />

        {/* main (yellow) roads */}
        <g stroke="#F2E9A0" strokeWidth="9" fill="none" strokeLinecap="round">
          <path d="M-10 120 L80 150 L150 250 L180 470" />
          <path d="M40 470 L120 300 L210 150 L300 120" />
        </g>
        <g stroke="#FBF6C8" strokeWidth="3" fill="none" strokeLinecap="round">
          <path d="M-10 120 L80 150 L150 250 L180 470" />
          <path d="M40 470 L120 300 L210 150 L300 120" />
        </g>
        {/* minor white roads */}
        <g stroke="#FFFFFF" strokeWidth="4" fill="none" strokeLinecap="round">
          <path d="M110 30 L120 150" />
          <path d="M170 30 L175 145" />
          <path d="M235 260 L300 300" />
          <path d="M120 300 L120 470" />
          <path d="M150 250 L60 300" />
        </g>

        {/* driven route (teal) */}
        <path
          d="M150 250 C150 210 175 195 175 165 C175 150 168 145 165 135"
          fill="none" stroke="#12A594" strokeWidth="5" strokeLinecap="round"
        />

        {/* labels */}
        <g fill="#7A756B" fontFamily="Outfit, sans-serif" fontStyle="italic">
          <text x="120" y="175" fontSize="12" fontWeight="700" fill="#4a4640">Uraidla</text>
          <text x="150" y="205" fontSize="7">Basket Range Rd</text>
          <text x="40" y="360" fontSize="7" transform="rotate(-58 40 360)">Greenhill Road</text>
          <text x="128" y="400" fontSize="7" transform="rotate(90 128 400)">Days Rd</text>
        </g>
        <g fill="#8a857b" opacity="0.7">
          <rect x="185" y="255" width="24" height="11" rx="2" fill="#EDE7DC" stroke="#C7C0B2" />
          <text x="189" y="264" fontSize="8" fontWeight="700" fill="#7A756B">B26</text>
        </g>
      </svg>

      {/* current position */}
      {showCurrent && (
        <div className="absolute" style={{ left: "50%", top: "54%", transform: "translate(-50%,-50%)" }}>
          <span className="absolute -inset-3 rounded-full bg-[#12A594]/25 pulse-ring" />
          <span className="grid place-items-center w-6 h-6 rounded-full bg-white ring-2 ring-[#12A594]">
            <span className="w-3.5 h-3.5 rounded-full bg-[#111]" />
          </span>
        </div>
      )}

      {/* dropped error pins */}
      {pins.map((p, i) => (
        <PinTag key={`${p.code}-${i}`} code={p.code} color={p.color} left={p.x} top={p.y} drop={p.drop} />
      ))}
    </div>
  );
}

function PinTag({ code, color, left, top, drop }) {
  return (
    <div
      className={`absolute z-10 ${drop ? "pin-drop" : ""}`}
      style={{ left, top, transform: "translate(-50%,-100%)" }}
    >
      <div className="relative flex flex-col items-center drop-shadow-[0_4px_8px_rgba(0,0,0,0.35)]">
        <div
          className="rounded-full px-2 py-1 text-white text-[9px] font-extrabold tracking-tight leading-none"
          style={{ background: color }}
        >
          {code}
        </div>
        <div className="w-2.5 h-2.5 -mt-1 rotate-45 rounded-[2px]" style={{ background: color }} />
      </div>
    </div>
  );
}
